(function () {
  var ROOT_SELECTOR = '.rich-text';
  var ITEM_SELECTOR = '[data-rt-gsap-text], [data-rt-gsap-image]';
  var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');

  function getTarget(item) {
    if (
      item.matches('.rich-text__text--positioned, .rich-text__text--overlap-item, .rich-text__image--positioned, .rich-text__image--overlap-item')
    ) {
      return item;
    }

    return item.querySelector('.rich-text__text--positioned, .rich-text__text--overlap-item, .rich-text__image--positioned, .rich-text__image--overlap-item') || item;
  }

  function getFromVars(effect) {
    if (effect === 'right_to_left') {
      return { autoAlpha: 0, x: 48 };
    }

    if (effect === 'left_to_right') {
      return { autoAlpha: 0, x: -48 };
    }

    if (effect === 'top_to_bottom') {
      return { autoAlpha: 0, y: -48 };
    }

    if (effect === 'bottom_to_top') {
      return { autoAlpha: 0, y: 48 };
    }

    if (effect === 'blur') {
      return { autoAlpha: 0, y: 24, filter: 'blur(12px)' };
    }

    if (effect === 'scale') {
      return { autoAlpha: 0, scale: 0.92, y: 16 };
    }

    if (effect === 'clip') {
      return { autoAlpha: 1, y: 0, clipPath: 'inset(0 0 100% 0)' };
    }

    return { autoAlpha: 0, y: 36 };
  }

  function getToVars(effect) {
    var vars = {
      autoAlpha: 1,
      x: 0,
      y: 0,
      scale: 1,
      duration: 0.9,
      ease: 'power3.out',
      clearProps: 'filter,clipPath'
    };

    if (effect === 'blur') {
      vars.filter = 'blur(0px)';
    }

    if (effect === 'clip') {
      vars.clipPath = 'inset(0 0 0% 0)';
    }

    return vars;
  }

  function addHover(item, target, cleanup) {
    if (item.dataset.rtGsapHover !== 'true') return;

    var move = function (event) {
      var rect = item.getBoundingClientRect();
      if (!rect.width || !rect.height) return;

      var x = (event.clientX - rect.left) / rect.width - 0.5;
      var y = (event.clientY - rect.top) / rect.height - 0.5;

      window.gsap.to(target, {
        x: x * 14,
        y: y * 10,
        rotationX: y * -4,
        rotationY: x * 5,
        duration: 0.45,
        ease: 'power2.out',
        overwrite: true
      });
    };

    var leave = function () {
      window.gsap.to(target, {
        x: 0,
        y: 0,
        rotationX: 0,
        rotationY: 0,
        duration: 0.55,
        ease: 'power3.out',
        overwrite: true
      });
    };

    item.addEventListener('mousemove', move);
    item.addEventListener('mouseleave', leave);
    item.addEventListener('blur', leave, true);

    cleanup.push(function () {
      item.removeEventListener('mousemove', move);
      item.removeEventListener('mouseleave', leave);
      item.removeEventListener('blur', leave, true);
    });
  }

  function initItem(item, cleanup) {
    if (item.dataset.rtGsapReady === 'true') return;
    if (typeof window.gsap === 'undefined' || REDUCED_MOTION.matches) return;

    var gsap = window.gsap;
    var ScrollTrigger = window.ScrollTrigger;
    var target = getTarget(item);
    var effect = item.dataset.rtGsapEffect || 'fade_up';
    var isPositioned =
      target.classList.contains('rich-text__text--positioned') ||
      target.classList.contains('rich-text__text--overlap-item') ||
      target.classList.contains('rich-text__image--positioned') ||
      target.classList.contains('rich-text__image--overlap-item');

    item.dataset.rtGsapReady = 'true';
    gsap.set(item, { perspective: 900 });
    if (isPositioned) {
      gsap.set(target, { xPercent: -50, yPercent: -50 });
    }

    if (ScrollTrigger) {
      gsap.registerPlugin(ScrollTrigger);
    }

    var tween = gsap.fromTo(
      target,
      getFromVars(effect),
      Object.assign(getToVars(effect), {
        scrollTrigger: ScrollTrigger
          ? {
              trigger: item,
              start: 'top 84%',
              toggleActions: 'play none none reverse'
            }
          : null
      })
    );

    cleanup.push(function () {
      if (tween.scrollTrigger) tween.scrollTrigger.kill();
      tween.kill();
      gsap.killTweensOf(target);
      delete item.dataset.rtGsapReady;
    });

    addHover(item, target, cleanup);
  }

  function init(root) {
    if (!root || root.dataset.rtGsapRootReady === 'true') return;

    var cleanup = [];
    root.dataset.rtGsapRootReady = 'true';
    root.querySelectorAll(ITEM_SELECTOR).forEach(function (item) {
      initItem(item, cleanup);
    });

    root._rtGsapCleanup = function () {
      cleanup.forEach(function (teardown) {
        teardown();
      });
      delete root._rtGsapCleanup;
      delete root.dataset.rtGsapRootReady;
    };
  }

  function initAll(scope) {
    (scope || document).querySelectorAll(ROOT_SELECTOR).forEach(init);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll(ROOT_SELECTOR).forEach(function (root) {
      if (root._rtGsapCleanup) root._rtGsapCleanup();
    });
  });
})();
